import React from 'react';

export const ArrowIcon = ({ size = 16, color = "#2E2E2E", rotate }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.237305 8.13147C0.237305 7.71726 0.573091 7.38147 0.987305 7.38147H15.0131C15.4273 7.38147 15.7631 7.71726 15.7631 8.13147C15.7631 8.54568 15.4273 8.88147 15.0131 8.88147H0.987305C0.573091 8.88147 0.237305 8.54568 0.237305 8.13147Z"
      fill="#2E2E2E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.94111 1.1778C8.234 1.47069 8.234 1.94557 7.94111 2.23846L1.51763 8.66193C1.22474 8.95482 0.749868 8.95482 0.456975 8.66193C0.164081 8.36904 0.164081 7.89416 0.456975 7.60127L6.88045 1.1778C7.17334 0.884907 7.64821 0.884907 7.94111 1.1778Z"
      fill="#2E2E2E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.94097 15.0853C7.64808 15.3782 7.17321 15.3782 6.88031 15.0853L0.456844 8.6618C0.163951 8.36891 0.163951 7.89403 0.456844 7.60114C0.749737 7.30825 1.22461 7.30825 1.5175 7.60114L7.94097 14.0246C8.23387 14.3175 8.23387 14.7924 7.94097 15.0853Z"
      fill="#2E2E2E"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/assets/icons/Arrow.icon.jsx